import React from 'react'
import { Heading } from 'arwes'
import styled from 'styled-components'

import Page from 'components/Page'
import Content from 'components/Content'
import ButtonLink from 'components/ButtonLink'
import Footer from 'components/Footer'

const Inner = styled.article`
  flex-direction: column;
  display: flex;
  align-items: center;
  text-align: center;
  z-index: 4;
`

const Landscape = styled.img`
  background: url(/mars-landspace.jpg);
  min-height: 100vh;
  position: absolute;
  width: 100%;
  background-position: top center;
  background-size: auto 100%;
  top: 0;
  z-index: 0;
`

const Title = styled.div`
color: white;
  font-family: 'Electrolize', 'sans-serif';
  font-weight: bold;
  text-transform: uppercase;
  font-size: 60px;
`

const Description = styled.h2`
  font-size: 40px;
  color: white;
`

const CallToAction = styled.p`
  font-size: 40px;
  padding: 20px;
  margin: 0;
`

export default function Index () {
  return (
    <>
      <Page>
        <Content>
          <Inner>
            <Heading node='h1'>
              <Title>
                Curiosity Rover Footage
                <Description>Discover NASA's Curiosity rover's footage on Mars</Description>
              </Title>
            </Heading>
            <ButtonLink to='photos'>
              <CallToAction>GO!</CallToAction>
            </ButtonLink>
          </Inner>
        </Content>
      </Page>
      <Landscape />
      <Footer />
    </>
  )
}
